<mat-form-field
  [appearance]="asFormsControl().outline ? 'outline' : 'legacy'"
  [floatLabel]="outlined ? 'always' : !asFormsControl().floatingLabelNever ? 'auto' : 'never'"
  class="custom-autocomplete"
>
  <mat-label *ngIf="asFormsControl().outline && !asFormsControl().floatingLabelNever">{{ asFormsControl().placeholder }}</mat-label>

  <input
    matInput
    #input
    type="text"
    autocomplete="off"
    [placeholder]="asFormsControl().placeholder"
    [disabled]="asFormsControl().disabled"
    [matAutocomplete]="autoComplete"
    (input)="filterOptions($event)"
    (paste)="filterOptionsOnPaste($event)"

    (click)="updateAutocompletePosition()"
    (focus)="updateAutocompletePosition()"
  >
  <i class="arrow-down-triangle" aria-hidden="true"></i>
  <mat-autocomplete
    #autoComplete="matAutocomplete"
    (optionSelected)="selectOption($event)"
    (opened)="onTouched && onTouched()"
  >
    <ng-container *ngIf="!asFormsControl().grouped; else groupedOptions">
      <mat-option
        *ngFor="let option of autocompleteOptions | async; trackBy: trackById"
        [value]="option.value">
        <div class="select-item" [ngClass]="{'select-item-with-icon': option.classes}">
          <span [ngClass]="!option.classes ? '' : option.classes"></span>
          <span> {{option.label}}</span>
        </div>
      </mat-option>
    </ng-container>
    <ng-template #groupedOptions>
      <ng-container *ngIf="!asFormsControl().visibleGroupName; else groupedWithName">
        <div
          *ngFor="let group of autocompleteGroups|async; let groupIndex = index"

          [ngClass]="{'bordered-group': groupIndex > 0}"
        >
          <mat-option *ngFor="let item of group.options.items; trackBy: trackById" [value]="item.value">
            <div class="select-item" [ngClass]="{'select-item-with-icon': item.classes}">
              <span [ngClass]="!item.classes ? '' : item.classes"></span>
              <span> {{item.label}}</span>
            </div>
          </mat-option>
        </div>
      </ng-container>

      <ng-template #groupedWithName>
        <mat-optgroup *ngFor="let group of autocompleteGroups | async" [label]="group.options.name">
          <mat-option *ngFor="let item of group.options.items; trackBy: trackById" [value]="item.value">
            <div class="select-item" [ngClass]="{'select-item-with-icon': item.classes}">
              <span [ngClass]="!item.classes ? '' : item.classes"></span>
              <span>{{item.label}}</span>
            </div>
          </mat-option>
        </mat-optgroup>
      </ng-template>
    </ng-template>
  </mat-autocomplete>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
  <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>

